import React from 'react'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {handleEmailSignupSubmission} from '~/app/utils/segment/eventHandlers'
import {InputWithCta} from '../ui/input-with-cta'
import useTpaMarketingConsent from '~/app/hooks/use-tpa-marketing-consent'

interface EmailSignupProps {
    whiteMode?: boolean
    placement: string
    className?: string
}

export const EmailSignup: React.FC<EmailSignupProps> = ({
    whiteMode,
    placement,
    className,
    ...props
}) => {
    const {site} = useMultiSite()
    const {setExplicitConsent, isTpaUser} = useTpaMarketingConsent()

    const handleSubmit = async (data: unknown): Promise<void> => {
        // React Hook Form passes the full form data object; pull out the
        // emailSignup field (keyed by InputWithCta's inputName below).
        const email = (data as {emailSignup?: unknown})?.emailSignup
        if (typeof email !== 'string') return

        if (isTpaUser) {
            await setExplicitConsent()
        }

        handleEmailSignupSubmission({
            siteName: site.id,
            email,
            emailChecked: true,
            placement
        })
    }

    return (
        <InputWithCta
            whiteMode={whiteMode}
            inputType="email"
            inputName="emailSignup"
            label="enter email address"
            ctaText="Sign Up"
            isRequired={true}
            submitMsg="Email Submitted"
            errorMsg="Please enter a valid email address"
            handleSubmit={handleSubmit}
            className={className}
            {...props}
            data-testid="emailSignup-InputWithCta"
        />
    )
}
